module.exports = __webpack_public_path__ + "img/doko-train.07ef129c.jpg";